import { createSelector } from '@reduxjs/toolkit';
import { createStructuredSelector } from 'reselect';
import { extractAssembly } from 'us_pcb_assembly/store/extractor';

export const selectCurrentVariant = (state) => state.usAssembly?.currentVariant;
export const selectAssemblyVariants = (state) => state.usAssembly?.assemblyVariants;
export const selectLoading = (state) => state.usAssembly?.loading;
export const selectAddingToCart = (state) => state.usAssembly?.addingToCart;
export const selectParameters = (state) => state.usAssembly?.parameters;
export const selectQuote = (state) => state.usAssembly?.quote;
export const selectQuoteStep = (state) => state.usAssembly?.quoteStep;
export const selectParametersChanged = (state) => state.usAssembly?.parametersChanged;
export const selectSuppliers = (state) => state.usAssembly?.suppliers;
export const selectDestroy = (state) => state.usAssembly?.destroy;
export const selectLineItemId = (state) => state.usAssembly?.lineItemId;
export const selectValidatorFlag = (state) => state.usAssembly?.validatorFlag;

export const selectAssemblyParameters = createStructuredSelector({
  loading: selectLoading,
  parameters: selectParameters,
  validatorFlag: selectValidatorFlag,
  quoteStep: selectQuoteStep,
});

export const selectAssemblyDataForPrices = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  quoteStep: selectQuoteStep,
  parametersChanged: selectParametersChanged,
  suppliers: selectSuppliers,
  assemblyVariants: selectAssemblyVariants,
});

export const selectAssemblyDataForQuote = createStructuredSelector({
  parameters: selectParameters,
  suppliers: selectSuppliers,
  variant: selectCurrentVariant,
});

export const selectAssemblyDataForValidate = createStructuredSelector({
  parametersChanged: selectParametersChanged,
  quoteStep: selectQuoteStep,
});

export const selectAssemblyDataForActions = createStructuredSelector({
  quote: selectQuote,
  quoteStep: selectQuoteStep,
  parametersChanged: selectParametersChanged,
  parameters: selectParameters,
});

export const selectAssemblyDataForCart = createSelector(
  [
    selectParameters,
    selectQuoteStep,
    selectQuote,
    selectLineItemId,
    selectCurrentVariant,
    selectAddingToCart,
  ],
  (
    parameters,
    quoteStep,
    quote,
    lineItemId,
    currentVariant,
    addingToCart,
  ) => {
    const assemblyDataForForms = {
      quoteStep,
      currentVariant,
      parameters,
    };

    return {
      assemblyProps: extractAssembly({ addingToCart, quoteStep, parameters, quote, lineItemId }),
      assemblyDataForForms,
    };
  },
);
